
// import { defineComponent, ref, inject } from "vue";
import { computed, defineComponent, ref } from "vue";
import { Todo } from "../types/Todo";
export default defineComponent({
    name: "Item",
    props: {
        todo: Object as () => Todo,
        index: {
            type: Number,
            require: true,
        },
        deleteTodo: {
            type:Function,
            require: true,
        },
        changeTodoisChecked: {
            type:Function,
            require: true,
        }
    },
    setup(props) {
        const bgColor = ref('white');
        const myColor = ref('black');
        const isShow = ref(false);
        const mouseHandler = (flag: boolean) => {
            if (flag) {
                bgColor.value = 'pink';
                myColor.value = 'green';
                isShow.value = true;
            } else {
                bgColor.value = 'white';
                myColor.value = 'black';
                isShow.value = false;
            }
        };
        // const deleteTodo: Function | undefined = inject('deleteTodo');
        // const del = () => {
        //     if (window.confirm('确定要删除吗？') && deleteTodo) {
        //         deleteTodo(props.i);
        //     }
        // }

        const del = () => {
            if (window.confirm('确定要删除吗？') && props.deleteTodo) {
                props.deleteTodo(props.index);
            }
        }

        const isComptete = computed({
            get() {
                return props.todo?.isChecked;
            },
            set(val) {
                props.changeTodoisChecked && props.changeTodoisChecked(props.todo, val);
            }
        })
        return {
            mouseHandler,
            bgColor,
            myColor,
            isShow,
            del,
            isComptete,
        };
    },
});
